
var Checkout = function(config) {
	var checkout = this;

	checkout.BTid = 0;

	checkout.config = $.extend({
		version: 7,
        endpoint: "",
        shipQuoteEndpoint: "",
		siteAbbr: "",
		siteName: "",
		siteNameFirstWord: "",
		contactInfo: {
			email: "",
			phone: "",
			phoneExtra: "",
			liveChatHref: "",
		},
		sessionInit: {},
		user: "",
		wireTransferFee: 0,
		productAdminEditURL: "",
		instoreTaxRate: 0,
		paypalError: undefined,
		bsPopoverData: 'bs.popover',
		cartItemProdIDKey: "productID",
		cartItemCount: '.cartCount',
		isEndeca: 0,
		suggestions: 1,
		prodImgSize: {
			small: 100,
			large: 300,
		},
		zipContainer: '#shipping_zip_container',
		isV2Checkout: 0,
		saveForLater: 0,
		employeeLoggedIn: 0,
		loggedInEmployee: {},
		employeePermissions: {},
	}, config);

    if (!checkout.config.endpoint) {
        console.error('endpoint required');
    }

    if (!checkout.config.shipQuoteEndpoint) {
        console.error('shipQuoteEndpoint required');
    }

	this.steps = [
		'cart',
		'shipping',
		'login',
		'billship',
		'payment'
	];

	this.paypalErrorMsg = (
		'There was an error contacting PayPal. Please try your request again.<br />'
		+ 'If this error continues please contact ' + checkout.config.siteName + ' Sales for support.'
	);

	this.user = config.user;
	this.delayTimers = {};
	this.shippingServiceCode = false;
	this.shippingCouriers = false;
	this.shippingServices = false;
	this.shippingRates = {};
	this.shippingServiceGroupID = false;
	this.shippingServiceGroupRates = {};
	this.shippingMultiLocations = 0;
	this.smartCartEligible = 0;
	this.isDomestic = false;

	this.session = false;
	this.remote = false;

	this.cart = false;
	this.shipping = false;
	this.login = false;
	this.billship = false;
	this.payment = false;
	this.suggestions = false;

	this.$submit = $('#checkout-submit');

	this.$submitIcon = $('#checkout-submit-icon');
	this.$submitIconLoading = $('#checkout-submit-icon-loading');

	this.init = function() {
		checkout.listen();
		checkout.remote = new Checkout.Remote(checkout);
		checkout.session = new Checkout.Session(checkout);
		checkout.cart = new Checkout.Cart(checkout);
		checkout.paypalCheckout = new Checkout.PayPalCheckout(checkout).buildContent();
		checkout.suggestions = new Checkout.Suggestions(checkout);
	};

	this.listen = function() {

		checkout.$submit.click(function() {
			checkout.submit();
		});

		$(document).click(function(e) {
			var $target = $(e.target || e.srcElement),
				targetStep = $target.parents('section').data('step');

			// For each displayed popover
			//$('.popover').each(function(i, popover) {
			//	var $popover = $(popover);
			//		$popoverLink = $popover.prev(),
			//		$targetPopover = $target,
			//		$targetPopoverLink = $target;
			//
			//	if (!$targetPopover.hasClass('popover'))
			//		$targetPopover = $target.parents('.popover').first();
			//
			//	if (!$target.hasClass('popover-link'))
			//		$targetPopoverLink = $target.parents('.popover-link').first();
			//
			//	if (
			//		// Clicked the popover link for this popover
			//		!$targetPopoverLink.is($popoverLink)
			//		// Clicked the popover content for this popover
			//		&& !$targetPopover.is($popover)
			//	)
			//		$popoverLink.popover('hide');
			//});

			if (
				$target.attr('id') != 'checkout-submit'
				&& !checkout.session.saved(targetStep)
			)
				checkout.session.save();
		});

		// Integer Only Input
		$('.intonly').keydown(checkout.intOnly);
		$('.floatonly').keydown(checkout.floatOnly);

		// Override bootstrap alert-close behavior (fadeOut/hide instead of remove)
		$('.alert').bind('close.bs.alert', function(e) {

			e.preventDefault();
			var $alert = $(this);

			$alert.fadeOut(function() {
				$alert.find('.msg-text').html('');
			});

		});
	};

	this.submit = function(onFail, initPaypalPayment) {
		var onFails = [function() {
				checkout.$submit.removeAttr('disabled');
				checkout.$submit.find('.btn-text').html('Place Order');
				checkout.$submitIcon.show();
				checkout.$submitIconLoading.hide();
			}],
			firstInvalidStep = false;

		if (onFail)
			onFails.push(onFail);

		checkout.$submit.attr('disabled', 'disabled');

		if (!initPaypalPayment) {
			checkout.$submit.find('.btn-text').html('Submitting...');
			checkout.$submitIcon.hide();
			checkout.$submitIconLoading.show();
		}

		$.each(checkout.steps, function(i, step) {

			if (initPaypalPayment && step == 'payment') {
				checkout.payment.removeErrors();
				return;
			}

			if (!checkout[step]) {
				firstInvalidStep = step;
				return;
			}

			if (
				checkout[step].validate
				&& !checkout[step].validate()
				&& !firstInvalidStep
			)
				firstInvalidStep = step;
		});

		if (firstInvalidStep) {
			checkout.scrollToInvalidStep(checkout[firstInvalidStep]);
			$.each(onFails, function(i, fail) { fail() });
			checkout.session.save();
			return false;
		}

		checkout.session.setAllData();

		var session = checkout.session.get();

		session.cartItems = checkout.cart.getItemData();
		session.totals = checkout.cart.totals.values;
		session.totals.taxRate = checkout.cart.totals.taxRate;

        var fullPaymentData = true;
        if (initPaypalPayment) {
            session.initPaypalPayment = 1;
            fullPaymentData = false;
        }

        // we need to prepare the payment data asyncronously before submitting the order
        checkout.payment.prepareData( function() {
            session.payments = checkout.payment.getData( fullPaymentData );

            // balances have covered the total, send no payment methods in submit data
            if (session.totals.remaining == 0 && session.totals.total != 0) {
                session.payments = [];
                session.paymentMethods = [];
                session.billID = null;
            }

            if (checkout.shippingServiceGroupID) { 
                session.shippingServiceGroupID = checkout.shippingServiceGroupID;
            } else { 
                delete session.shippingServiceGroupID;
            } 
            session.shippingServiceCode = checkout.shippingServiceCode;
            session.smartCartEligible = checkout.smartCartEligible || 0;

            // taxCode is only for shipping
            delete( session.billing.taxCode );

            // Order Submit saves the session
            $.each(checkout.steps, function(i, step) {
                if (checkout[step])
                    checkout[step].saved = true;

            });

            var submission = new Checkout.Submit(checkout, {
                'onFails' : onFails
            });
            
            if (checkout.config.saveForLater) {
                checkout.cart.saveForLater.syncWishList();
            }

            submission.submit({
                'step'   : 'submit',
                'action' : 'submit',
                'data'   : encodeURIComponent(JSON.stringify(session)),
                'options': encodeURIComponent(JSON.stringify( { 'newSite': checkout.config.isEndeca, 'isV2Checkout': checkout.config.isV2Checkout } )),
            });
        } );
	};

	// Checkout Global Utils

	this.alignMiddle = function($child, $parent) {
		$child.css('margin-top', ($parent.height() / 2) - ($child.height() / 2));
	};

	this.delayChange = function($el, time, done) {
		if (checkout.delayTimers[$el])
			clearTimeout(checkout.delayTimers[$el]);

		checkout.delayTimers[$el] = setTimeout(done, time);
	};

	this.scrollToInvalidStep = function(step) {
		var $firstInvalidField = step.$wrap.find('.field-error:visible, .alert-error:visible').first();

		if ($firstInvalidField.length)
			checkout.scrollToCenter($firstInvalidField);
		else
			$('html,body').animate(
				{ 'scrollTop': step.$anchor.offset().top },
				500
			);

	};

	this.scrollToCenter = function($el) {
		var viewportHeight = jQuery(window).height(),
			elHeight = $el.height(),
			elOffset = $el.offset();

		$('html,body').animate(
			{ 'scrollTop': (elOffset.top + (elHeight/2) - (viewportHeight/2)) },
			500
		);
	};

	this.intOnly = function(e) {
		var code = (e.keyCode ? e.keyCode : e.which),
			codeStr = code + '';

		// control keys are allowed
		if (codeStr.match(/^(8|9|13|16|17|18|20||27|33|34|37|38|39|40|46)$/))
			return true;

		// numbers above letters are allowed
		if (code >= 48 && code <= 57)
			return true;

		// numberpad numbers are allowed
		if (code >= 96 && code <= 105)
			return true;

		return false;
	};

	this.floatOnly = function(e) {
		var code = (e.keyCode ? e.keyCode : e.which),
			codeStr = code + '';

		// control keys are allowed
		if (codeStr.match(/^(8|9|13|16|17|18|20||27|33|34|37|38|39|40|46)$/))
			return true;

		// numbers above letters are allowed
		if (code >= 48 && code <= 57)
			return true;

		// numberpad numbers are allowed
		if (code >= 96 && code <= 105)
			return true;

		// decimal/period is allowed
		if (code == 190 || code == 110)
			return true;

		return false;
	};

	this.switchCheckoutVersion = function(v) {
		checkout.remote.call({
			'type': 'POST', 
			'data': {
				'step': 'session',
				'action': 'switchCheckoutVersion',
				'checkoutVersion': v
			}
		})
		.done(function() {
			window.location.reload(true);
		});
	};

	this.init();
};
